import React from 'react';

const shareBtnStyle = (bg) => ({
  padding: "12px", borderRadius: "12px", background: bg, color: "white", 
  border: "none", fontWeight: "bold", fontSize: "0.7rem", cursor: "pointer", 
  letterSpacing: "1px", width: "100%"
});

export default function ShareModal({ isOpen, onClose, url, text, showToast }) {
  if (!isOpen) return null;

  return (
    <div 
      style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.9)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }} 
      onClick={onClose}
    >
      <div 
        style={{ background: "#111", padding: "30px", borderRadius: "25px", width: "90%", maxWidth: "350px", border: "1px solid #00acc1", textAlign: "center" }} 
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ color: "#00acc1", marginBottom: "20px", fontSize: "0.9rem", letterSpacing: "2px" }}>SHARE SELECTION</h3>
        
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button style={shareBtnStyle("#25D366")} onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(text + "\n\n" + url)}`, '_blank')}>WHATSAPP</button>
          <button style={shareBtnStyle("#0088cc")} onClick={() => window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank')}>TELEGRAM</button>
          <button style={shareBtnStyle("#333")} onClick={async () => { await navigator.clipboard.writeText(url); showToast("Link in Zwischenablage kopiert! 📋"); onClose(); }}>LINK KOPIEREN</button>
          <button style={shareBtnStyle("#555")} onClick={() => window.location.href = `mailto:?subject=streetwise RADIO&body=${encodeURIComponent(text + "\n\n" + url)}`}>E-MAIL</button>
        </div>
        
        <button onClick={onClose} style={{ background: "none", border: "none", color: "#444", marginTop: "20px", fontSize: "0.7rem", cursor: "pointer", fontWeight: "bold" }}>SCHLIESSEN</button>
      </div>
    </div>
  );
}